import React, { Component } from 'react';
import PropTypes from 'prop-types';
import qs from 'query-string';
import { Button } from 'reactstrap';
import client from '../../../client';
import config from '../../../config';
import paymentImg from "../../../buisness-banking-f8dca509.png"

class ProcessPayment extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      ccavUrl: null,
      orderId: null,
      nttdata: null,
      nttdataStatus: null,
      payu: null

    }
    this.pay = this.pay.bind(this);
  }

  componentDidMount() {
    const { router: { history: { location: { search } } } } = this.context;
    qs.parse(search);
    console.log(qs.parse(search))

    const nttdataAuth = JSON.parse(localStorage.getItem('nttdataAuth'));
    this.setState({
      ccavUrl: qs.parse(search)['pay'], orderId: qs.parse(search)['orderId'], nttdataAuth: nttdataAuth,
      nttdata: qs.parse(search)['nttdata'], nttdataStatus: qs.parse(search)['fail'], nttdataBack: qs.parse(search)['backWf'],
      payu: qs.parse(search)['payu'], payStatus: qs.parse(search)['status']
    })
  }

  notifyParent(orderId) {
    if (window.opener && window.opener.callbacks) {
      window.opener.callbacks['paymentCallback' + orderId]();
    }
  }

  pay() {
    const payload = this.state.nttdataAuth;
    localStorage.setItem('nttdataAuth', null)
    client().post(`${config.authAPI}/payment/getAuth`, payload).then((res) => {
      const options = {
        "atomTokenId": res.data.token,
        "merchId": res.data.merchId,
        "custEmail": payload.customerEmail,
        "custMobile": payload.customerPhone,
        "returnUrl": `${config.authAPI}/payment/response`  // replace with your return URL
      }

      let atom = new window.AtomPaynetz(options, 'uat');

    }).catch(error => {
      console.log('Payment Failed: ', error);
    })

  }

  render() {
    const { router: { history } } = this.context;

    console.log("hasd", this.props)
    if (this.state.ccavUrl) return (
      <center>
        {
          this.state.ccavUrl && <iframe width="80%" height="1200" scrolling="No" frameBorder="0" id="paymentFrame" src={this.state.ccavUrl}></iframe>
        }
        <script src="https://ajax.googleapis.com/ajax/libs/jquery/1.10.2/jquery.min.js"></script>
      </center>
    );
    if (this.state.orderId && !this.state.nttdata && !this.state.payu) return (
      <div>
        {
          this.notifyParent(this.state.orderId)
        }
      </div>
    )
    if (this.state.payu) return (
      <div className='continue-to-payemnt-div'>
        <div className='content-handler-div'>
          <div className='content-div'>
            <h3>
              Pay with PAYU
            </h3>
            {
              this.state.payStatus == 'success' ? <p>✅ Success ! Your Payment is Confirmed.</p> :
                <p> Fail ! Your Payment is failed. Error : {this.state.payStatus}</p>

            }
            <Button className="zoom-in-out-button" name='back'
              onClick={() => {

                window.close()
              }}
              block
              color='primary'

            >Close  <i className='fa fa-arrow-circle-right'></i></Button>

          </div>
        </div>

      </div>
    );
    if (this.state.nttdata) return (
      // <div className='m-4' style={{
      //   left: '45%', position: 'absolute', borderRadius: 5,
      //   border: '1px solid #ccc ', padding: '15px', width: '15%'
      // }}>

      //   <p className='m-4'>{this.state.nttdataStatus == true ? 'Payment Failed' : 'Payment Success'}</p>
      //   <Button name='back'
      //     onClick={() => {
      //       localStorage.setItem('nttdataTxnId', this.state.orderId)
      //       window.close()
      //     }}
      //     block
      //     color='primary'

      //   >Close</Button>


      // </div>
      <div className='continue-to-payemnt-div'>
        <div className='head-div'>
          <h2>Continue with NTT Business Banking</h2>
        </div>
        <div className='content-handler-div'>
          <div className='content-div'>
            <h3>
              Pay with NTT
              <span className='text-greenLight'>{" "}Business Banking</span>
            </h3>
            <p>✅ Success ! Your Payment is Confirmed.</p>
            <p>  We’ve received your payment, and everything is good to go! You’ll receive a confirmation email with the details shortly.</p>

            <Button className="zoom-in-out-button" name='back'
              onClick={() => {
                localStorage.setItem('nttdataTxnId', this.state.orderId)
                window.close()
              }}
              block
              color='primary'

            >Close  <i className='fa fa-arrow-circle-right'></i></Button>


          </div>
          <div className='img-handler-div'>
            <img src={paymentImg} />
          </div>
        </div>

      </div>
    );
    if (this.state.nttdataAuth) return (
      <div className='continue-to-payemnt-div'>
        <div className='head-div'>
          <h2>Continue with NTT Business Banking</h2>
        </div>
        <div className='content-handler-div'>
          <div className='content-div'>
            <h3>
              Pay with NTT
              <span className='text-greenLight'>{" "}Business Banking</span>
            </h3>
            <p>Click on the below button to continue</p>
            <Button className="zoom-in-out-button" name='pay'
              onClick={() => {
                this.pay()
              }}
              block
              color='primary'

            >Continue Payment <i className='fa fa-arrow-circle-right'></i></Button>

          </div>
          <div className='img-handler-sdiv'>
            <img src={paymentImg} />
          </div>
        </div>

      </div>
    );
    return <div></div>
  }
}

ProcessPayment.contextTypes = {
  router: PropTypes.object
}


export default ProcessPayment;
